<!-- PaymentIcon.vue -->
<template>
  <svg :class="iconClass" width="24" height="24" viewBox="0 0 24 24" fill="none">                
    <path d="M6.67591 23H2.86441C1.83474 23 1 22.1653 1 21.1356V2.8644C1 1.83474 1.83474 0.999994 2.86441 0.999994H11.8136C12.3284 0.999994 12.7945 1.20867 13.1319 1.54608L14.9963 3.41049C15.3337 3.74785 15.5424 4.21395 15.5424 4.72881V9.86427" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19.8173 10.8619C20.5454 10.1338 21.7259 10.1338 22.4539 10.8619C23.182 11.59 23.182 12.7705 22.4539 13.4986L14.7478 21.2047C14.6127 21.3398 14.4576 21.4534 14.288 21.5414L11.6772 22.8956C11.3262 23.0777 10.8835 23.0215 10.5889 22.727C10.2943 22.4324 10.2381 21.9897 10.4202 21.6386L11.7745 19.0279C11.8625 18.8583 11.976 18.7032 12.1111 18.568L19.8173 10.8619Z" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.72882 8.08475H11.8136" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.72882 11.8136H11.8136" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.72882 15.5424H8.08475" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>
